export enum FrontendPaymentSource {
    CV_SEARCH = 'CV_SEARCH',
    APPLICANTS_LIST = 'APPLICANTS_LIST',
    APPLICANT_DETAILS = 'APPLICANT_DETAILS',
    APPLICANT_DETAILS_SUBSCRIBED = 'APPLICANT_DETAILS_SUBSCRIBED',
    JOB_LIST = 'JOB_LIST',
    JOB_LIST_SUBSCRIBED = 'JOB_LIST_SUBSCRIBED',
    PMA = 'PMA',
    CHAT = 'CHAT',
    BILLING_HISTORY_UPGRADE = 'BILLING_HISTORY_UPGRADE',
    PLANS_PAGE = 'PLANS_PAGE',
    SAUD_VETTING = 'SAUD_VETTING',
    ADVANCED_FILTERS = 'ADVANCED_FILTERS',
    PROMOTE_JOB = 'PROMOTE_JOB',
    PDF_CV_CV_SEARCH = 'PDF_CV_CV_SEARCH',
    PDF_CV_APPLICANT = 'PDF_CV_APPLICANT',
    VIDEO_CV = 'VIDEO_CV',
    RECOMMENDATIONS_LIST = 'RECOMMENDATIONS_LIST'
}